import React from 'react';
import { AccordionComponentProps } from './AccordionComponent.types';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    marginBottom: (props: AccordionComponentProps) =>
      props.gapBetweenAccordion
        ? typeof props.gapBetweenAccordion === 'number'
          ? props.gapBetweenAccordion
          : 5
        : 0,
  },
});

export const AccordionComponent: (
  props: AccordionComponentProps
) => JSX.Element = props => {
  const { accordionDataList } = props;
  const classes = useStyles(props);
  return (
    <div>
      {accordionDataList.map((accordion, ix) => {
        const {
          accordionDetails,
          accordionSummary,
          className,
          expanded,
          onChange,
          disabled = false,
          expandIcon,
          square = false,
        } = accordion;
        return (
          <Accordion
            classes={classes}
            key={`${ix}_accordion`}
            className={className}
            expanded={expanded}
            onChange={onChange}
            disabled={disabled}
            square={square}
          >
            <AccordionSummary
              expandIcon={expandIcon}
              className={accordionSummary.className}
            >
              {accordionSummary.element}
            </AccordionSummary>
            <AccordionDetails className={accordionDetails.className}>
              {accordionDetails.element}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};
